export interface IDocumentInputModel {
  DocId?: number|null
  GroupId: number
  DocNo: string
  DocTitle: string
  DocDate: string
  ProjectId: number
  UserId: number
  DocSerialNo: number
  SchRevNo: number
  IsScheduled: boolean
  DocSheetNo: number
  Module: number
  elementDetails: IElementInputModel[]
  docRevInputs: IDocumentRevInputModel
  docFLInputs: IDocumentLocInputModel
}

export class DocumentOutputModel {
  public DocId!: number|null
  public RevisionNo!: string
  public DocAuthorizedBy!: number|null
  public result!: string
  public successCode!: number
  public successMessage!: string
}
export interface IDocumentElementViewModel {
  DEDId?: number
  DEDDescription: string
  DEDShortDescription: string
  DEDName: string
  SortBy: number
}
export interface IDocumentSLModel {
  DocSLNumber: string
}

export interface IElementInputModel {
  deId: number
  deDescription: string
  dedId: number
  dedDescription: string
  dedShortDescription: string
  sortBy: number
}
export interface IDocSLNoInputModel {
  projectId: number
  groupId: number
  moduleId: number
  elementDetails: IElementInputModel[]
}

export interface IDocumentRevInputModel {
  DocId: number|null
  RevisionNo: string
  DocStatus: number
  IsConfidential: boolean
  PrintSize: number
  Reference: string
  RevisedOn: string
  RevisionCategory: number
  DocAuthorizedBy: number
  DocCreatedBy: number
  Comments: string
  IsFileAttached: boolean
  QRCodeStatus: boolean
  CreatedBy: number
}
export interface IDocumentLocInputModel {
  DocId: number|null
  RevisionNo: string
  Location: string
  Building: string
  Floor: string
  Rack: string
  Shelf: string
  FileNo: string
  UserId: number
}

export interface IDocumentTemplateInputModel {
  ProjectId: number
  GroupId: number
  memberId?: number
}

export interface IDocumentExcelUploadModel {
  result: string
  successCode: number
  successMessage: string
  statusList: IDocumentUploadStatusModel[]
}

export interface IDocumentUploadStatusModel {
    rowNo: number,
    docNo: string,
    revisionNo: string,
    errors: string[],
    status: boolean,
    docId? : number,
    authorisedBy : number
    revisedOn: string
}

export interface IDocumentTemplateStatusModel {
  docId? : number,
  rowNo: number,
  docNo: string,
  revisionNo: string,
  errors: string[],
  status: boolean
}

export interface IDocumentListInputModel {
  projectId?: number,
  groupId?: number,
  memberId?: number,
  transType?: string,
  createdFromDays?: number,
  docId?: number| null,
  docNo?: string| null,
  revisionNo?: string| null,
  isExcludeTransmittalDocuments?: boolean
  docTitle? : string|null,
  reference? : string|null,
  fromDate? : Date | null,
  toDate? : Date | null
}

export interface IDocumentListModel {
  docNo: string,
  revisiedOn: string,
  revision: string,
  title: string,
  authorizedBy: string,
  createdBy: string,
  status: string,
  AccountingCentre: string
}

export interface IDocumentRevHistoryModel {
  docId: number,
  groupId: number,
  memberId: number,
  transType: string
}

export interface IDocRevHistoryOutputModel {
  slNo: number,
  documentId: number,
  documentNo: string,
  title: string,
  revision: string,
  docStatusId: number,
  docStatusDesc: string,
  currentStatusDesc: string,
  currentStatusId: number,
  groupId: number,
  createdBy: number,
  createdByName: string,
  authorisedBy: number,
  authorizedByName: string,
  revisedOn?: Date,
  createdOn?: Date,
  reviewedOn?: Date,
  modifiedOn?: Date,
  revCategoryDesc: string,
  revCategoryId: number,
  printSizeDesc: string,
  printSizeId: number,
  noOfSheets: number
}

export interface IDocumentApprovalModel {
  DocId: number
  RevisionNo: string
  RevisedOn: string
  IsApproved: boolean
  ApprovedBy: number
}

export interface IDocumentByIdInputModel {
  projectId: number,
  groupId: number,
  docId: number,
  revisionNo: string
}

export interface IDocumentSearchModel {
  projectId: number,
  memberId: number,
  searchId: number,
  searchName: string,
  docNo: string,
  docTitle: string,
  groupId: number,
  revisionNo: string,
  docStatus: string,
  createdType: string,
  createdPeriod: number,
  searchText: string
}

export interface IDocumentShareModel {
  DocId: number
  RevisionNo: string
  MemberId: number
  UserId: number
}

export interface IDocumentShareMailModel {
  DocId: number
  RevisionNo: string
  MemberIdString: string
  UserId: number
}

export type DocumentShareMemberModel = {
  documentId: number,
  revision: string,
  memberId: number,
  memberName: string
}

export interface IDocumentMailInputModel {
  DocId: number
  DocumentNo: string
  Category: number
  ProjectId: number 
  GroupId: number
  MemberId?: number
  TransType: string
  revisionNo: string|null
}

export interface IDocumentMailOutputModel {
  messageId: number
  messageNumber: string
  messageSubject: string
  messageCategory: number
  from: string
  to: string
  sentOn?: Date
  respondBy?: Date
  dateOfResponse?: Date
  status: string
}

export class DocumentGridSettings {
  constructor(defaultValue: boolean) {

    this.docNo = defaultValue;
    this.title = defaultValue;
    this.revision = defaultValue;
    this.revisedOn = defaultValue;
    this.createdBy = defaultValue;
    this.authorizedByName = defaultValue;
    this.status = defaultValue;
    this.reference = defaultValue;
  }
  docNo: boolean;
  title: boolean;
  revision: boolean;
  revisedOn: boolean;
  createdBy: boolean;
  authorizedByName: boolean;
  status: boolean;
  reference: boolean
}
export interface IDocumentRepositoryHistoryInputModel {
  docId : number,
  revision : string 
}
export interface IDocumentRepositoryHistoryViewModel {
  assigned_By: string,
  assigned_To: string,
  assigned_On: number,
  viewStatus: string,
  viewed_On: number,
  communication: string
}

export interface IDocReceiverStatus {
  doc_Id: number,
  member_Id: number,
  is_Read?: string,
  read_On?: Date,
  revisionNo: string
}
export interface IDocumentDynamicSearchModel { 
  projectId: number,
  memberId: number,
  docNo: string,
  docTitle: string,
  groupId: number,
  revisionNo: string,
  docStatus: string,
  createdType: string,
  createdPeriod: number,
  searchText: string
}
export interface IMSTOutputModel{
  topSheet_No: string
  topSheet_Desc: string
  topsheet_Description: string
  pO_No: string
  material_Code: string
  material_desc: string
  material_Code_Desc: string
  material_Code_Description: string
}

export interface IMSTDocDetailsInputModel {
  projectId: number
  docId: number
  sSTDetails: IMSTDetailsInputModel[]
  userId: number
 
}

export interface IMSTDetailsInputModel{
  topSheetNo: string|null
  pONo: string|null
  materialItemCode: string|null
  isActive: boolean
}
